module.exports = __webpack_public_path__ + "static/media/CarAdvise-Logo.e642d56d.svg";